import React from 'react'
import logo from './Cuberton.gif'

export const Logo = () => {
  return (
    <a href="https://www.ppuunnkk.com" target="_blank" rel="noopener noreferrer">
      <img src={logo} alt="Cuberton" height="72" width="72" style={{ display: 'block' }} />
    </a>
  )
}
